import React from "react";
import SlProgressBar from "@shoelace-style/shoelace/dist/react/progress-bar";
import "./ProgressBar.css";

export type ProgressStatus =
  | "preparing"
  | "polling"
  | "completed"
  | "timeout"
  | "error";

interface Props {
  /** null cuando el avance es indeterminado y la barra debe animarse sin porcentaje. */
  percent: number | null;
  status?: ProgressStatus;
  elapsedMs?: number;
  /** @deprecated Ya no se muestra el límite de timeout en la UI. */
  timeoutMs?: number;
  label?: string;
  cantidadRegistros?: number;
  cantidadRegistrosOracle?: number;
  errorMessage?: string | null;
  className?: string;
}

const formatElapsed = (ms: number): string => {
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
};

function ProgressBar({
  percent,
  status = "polling",
  elapsedMs,
  label,
  cantidadRegistros,
  cantidadRegistrosOracle,
  errorMessage,
  className = "",
}: Props) {
  const indeterminate = status !== "completed" && percent === null;
  const clamped =
    status === "completed"
      ? 100
      : Math.max(0, Math.min(100, Math.round(percent ?? 0)));

  const statusClass =
    status === "completed"
      ? "progress-bar-completed"
      : status === "error"
      ? "progress-bar-timeout"
      : status === "timeout"
        ? "progress-bar-timeout"
        : status === "preparing"
          ? "progress-bar-preparing"
          : "progress-bar-polling";

  const statusLabel =
    status === "completed"
      ? "Completado"
      : status === "error"
      ? "Error"
      : status === "timeout"
        ? "Tiempo excedido"
        : status === "preparing"
          ? "Preparando descarga..."
          : "Sincronizando...";

  const enProgreso = status === "preparing" || status === "polling";

  return (
    <div className={`progress-bar-wrapper ${statusClass} ${className}`}>
      <div className="progress-bar-header">
        <span className="progress-bar-label">{label ?? statusLabel}</span>
        {!indeterminate && (
          <span className="progress-bar-percent">{clamped}%</span>
        )}
      </div>
      <SlProgressBar
        value={clamped}
        indeterminate={indeterminate}
        className="progress-bar-shoelace"
        // @ts-ignore
        style={{ "--height": "8px" }}
      />
      <div className="progress-bar-meta">
        {status === "error" && errorMessage && <span>{errorMessage}</span>}
        {typeof cantidadRegistros === "number" &&
          typeof cantidadRegistrosOracle === "number" && (
            <span>
              {cantidadRegistros}/{cantidadRegistrosOracle} registros
            </span>
          )}
        {typeof elapsedMs === "number" && enProgreso && (
          <span>{formatElapsed(elapsedMs)}</span>
        )}
      </div>
    </div>
  );
}

export default ProgressBar;
